export default __webpack_public_path__ + "static/media/11.20f65b92.png";